import { Injectable } from "@angular/core";
import {
  GA_BACKOFFICE_ADMINISTRATOR,
  GA_BACKOFFICE_APPROVER_MANAGER,
  GA_BACKOFFICE_EXTERNAL,
  GA_BACKOFFICE_OPERATION,
  GA_CAR_WORKSHOP,
  GA_DRIVER_PERFIL,
  GA_FLEET_ADMIN
} from "@core/constants";
import { RoleEnum } from "@shared/enums/roles.enum";
import { KeycloakHelperService } from "./keycloak.helper.service";

@Injectable({
  providedIn: "root"
})
export class GoogleAnalyticsService {
  constructor(private keycloakHelperService: KeycloakHelperService) {}

  sendEvent(eventName: string, action?: string, context?: string): void {
    const event = `${this.getUserProfileAbbreviation()}_${eventName}`;
    gtag("event", event);
  }

  sendPage(pageName: string) {
    const page = `${this.getUserProfileAbbreviation()}_${pageName}`;
    gtag("event", page);
  }

  private getUserProfileAbbreviation(): string {
    switch (this.keycloakHelperService.getTypeUser()) {
      case RoleEnum.FLEET_ADMIN:
        return GA_FLEET_ADMIN;

      case RoleEnum.FLEET_ADMIN_APPROVER:
        return GA_FLEET_ADMIN;

      case RoleEnum.DRIVER_PERFIL:
        return GA_DRIVER_PERFIL;

      case RoleEnum.DRIVER_APPROVER:
        return GA_DRIVER_PERFIL;

      case RoleEnum.CAR_WORKSHOP:
        return GA_CAR_WORKSHOP;

      case RoleEnum.BACKOFFICE_OPERATION:
        return GA_BACKOFFICE_OPERATION;

      case RoleEnum.BACKOFFICE_EXTERNAL:
        return GA_BACKOFFICE_EXTERNAL;

      case RoleEnum.BACKOFFICE_ADMINISTRATOR:
        return GA_BACKOFFICE_ADMINISTRATOR;

      case RoleEnum.BACKOFFICE_APPROVER_MANAGER:
        return GA_BACKOFFICE_APPROVER_MANAGER;

      default:
        return "";
    }
  }
}
